import { Loader2 } from 'lucide-react'

interface AuditProgressProps {
  progress: { done: number; total: number; current: string } | null
  className?: string
}

export function AuditProgress({ progress, className = '' }: AuditProgressProps) {
  if (!progress || !progress.total) return null

  const pct = Math.round((progress.done / progress.total) * 100)

  return (
    <div className={`space-y-2 ${className}`}>
      <div className="flex items-center justify-between text-sm">
        <span className="text-[#555A73]">
          <Loader2 size={14} className="inline-block mr-1.5 animate-spin" />
          Audit en cours...
        </span>
        <span className="text-[#1B2559] font-medium">{progress.done}/{progress.total} requetes</span>
      </div>
      <div className="h-2 bg-[#E2E4ED] rounded-full overflow-hidden">
        <div
          className="h-full bg-[#6366F1] rounded-full transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
      {progress.current && (
        <p className="text-xs text-[#8B8FA7] truncate">Requete en cours : {progress.current}</p>
      )}
    </div>
  )
}
